import { Layout } from 'components/shared/Layout';
import { FC, useState } from 'react';
import { AdminSwitchCases } from './types';
import ResetPasswordView from 'components/modules/Admin/ResetPassword';
import AdminPage from '.';

const ResetPasswordPage: FC = () => {
  const [route, setRoute] = useState(AdminSwitchCases.resetPassword);

  const routeTo = (name: AdminSwitchCases) => {
    setRoute(name);
  };
  const switchView = () => {
    switch (route) {
      case AdminSwitchCases.resetPassword:
        return (
          <ResetPasswordView
            routeTo={() => routeTo(AdminSwitchCases.adminPage)}
          />
        );
      case AdminSwitchCases.adminPage:
        return <AdminPage />;
      default:
        return null;
    }
  };

  return <Layout>{switchView()}</Layout>;
};

export default ResetPasswordPage;
